angular.module('fauzanKhanQueryBuilder', [
    'ui.tinymce', // for custom bracketing
    'angularModalService' // for custom bracketing
]);